import request from '@/utils/request'

export function getList(data) {
  return request({
    url: '/Api/brand.Point/getServicePointList',
    method: 'post',
    data
  })
}

export function addOrEdit(data) {
  return request({
    url: '/Api/brand.Point/addOrEdit',
    method: 'post',
    data
  })
}

export function getDetail(data) {
  return request({
    url: '/Api/brand.Point/getDetail',
    method: 'post',
    data
  })
}

export function getInviteqrList(data){
	return request({
		url: '/Api/brand.CustInviteqr/index',
		method: 'post',
		data
	})
}

export function setInviteqrRemark(data){
	return request({
		url: '/Api/brand.CustInviteqr/updateRemark',
		method: 'post',
		data
	})
}

export function delInviteqr(data){
	return request({
		url: '/Api/brand.CustInviteqr/delInviteqr',
		method: 'post',
		data
	})
}
export function createInviteqr(data){
	return request({
		url: '/Api/brand.CustInviteqr/create',
		method: 'post',
		data
	})
}